export const GridNames = {
  PRIMARY_TEXT: "PrimaryTextGrid",
  SECONDARY_TEXT: "SecondaryTextGrid",
  NEGATIVE_TEXT: "NegativeTextGrid",
  BENCHMARK_SKILLS: "BenchmarkSkillsGrid",
  BENCHMARK_MICROSKILLS: "BenchmarkMicroSkillsGrid",
  BENCHMARK_JFA: "BenchmarkJFAGrid",
};
